module.exports = {
    name: 'Grow with Anna',
    logo: 'https://img.genflow.com/grow/checkout/fav.png',
    vendorUUID: process.env.GATSBY_VENDOR_UUID,
    metaData: {
        title: 'Grow with Anna',
        description: 'Download GROW and start your journey to achieving your goals today',
        author: 'GENFLOW',
        url: 'https://growwithanna.com',
        image: 'https://img.genflow.com/grow/checkout/fav.png',
    },
    theme: {
        colors: { // Note these need to be copied into $theme-colors in src/styles/global.scss
            primary: '#ef7d4e',
            text: '#697386',
            ctaText: '#fff',
        },
    },
    analytics: {
        gtag: '',
        facebookPixel: '',
        tagManager: 'GTM-M5DHZS3',
        // segment: '', - Stored in env
    },
    links: {
        terms: 'https://growwithanna.com/pages/terms-and-conditions',
        privacy: 'https://growwithanna.com/pages/privacy-policy',
        support: 'https://growwithanna.zendesk.com/hc/en-gb',
        author: 'https://genflow.com',
        ios: 'https://apps.apple.com/us/app/grow-with-anna/id1623403112',
        android: 'https://play.google.com/store/apps/details?id=com.growwithanna.app',
    },
    forms: {
        errors: {
            existingUser: 'This user already exists, please login.',
            invalidPassword: 'The password needs to have 6 or more characters.',
            unknownError: 'The registration could not be processed.',
            userNotFound: 'Incorrect email/password combination.',
        },
    },
    pages: {
        register: {
            title: 'Sign Up to',
            ctaText: 'Register',
            ctaLoadingText: 'Registering',
        },
        login: {
            title: 'Login to',
            ctaText: 'Login',
            ctaLoadingText: 'Logging In',

        },
    },
    products: [
        {
            title: '1 Month',
            // product: '1month',
            product: '1monthsale',
            // coupon: 'YC3qAIav',
            // label: '20% OFF',
        }, {
            title: '6 Months',
            // product: '6month',
            product: '6monthsale',
            // coupon: 'VezjmZNM',
            // label: 'BIGGEST SAVING',
        }, {
            title: '12 Months',
            // product: '12month',
            product: '12monthsale',
            // coupon: '3ulJuqQT',
            // label: '25% OFF',
        },
    ],
};
